import {Injectable} from '@angular/core';
import {Response, InvoiceEmail, InvoiceGet, InvoicePost, InvoicesService as API,} from '../../generated/sales-terminal-client';
import {LanguageService} from '../language/language.service';
import {UtilService} from '../util/util.service';
import moment from 'moment';
import {Observable, tap} from "rxjs";
import {SnackService} from "../snack/snack.service";
import {InvoiceData} from '../../modules/sales-terminal/transactions/invoice-modal/invoice-generate-modal.component';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  constructor(private api: API,
              private languageService: LanguageService,
              private utilService: UtilService,
              private snackService: SnackService) {}

  public generateInvoice(transactionId: number, data: InvoiceData, legacy = true): Observable<InvoiceGet> {
    const invoice = new class implements InvoicePost {
      customerUuid: string = data.customerUuid;
      description: string = data.description;
      comment: string = data.comment;
      dueDate: string = data.dueDate;
      legalPersonId: number = data.legalPersonId;
    };
    const generateInvoiceCall = legacy
      ? this.api.transactionIdInvoicePost(transactionId, this.languageService.selectedLang, invoice)
      : this.api.generateInvoiceForSelfServiceTransaction(transactionId, this.languageService.selectedLang, invoice);
    return generateInvoiceCall.pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    )
  }

  public getInvoice(invoiceUuid: string): Observable<InvoiceGet> {
    return this.api.getInvoiceByInvoiceUuid(invoiceUuid).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public getSentInvoiceEmails(invoiceUuid: string): Observable<Array<InvoiceEmail>> {
    return this.api.getEmails(invoiceUuid).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public sendEmails(invoiceUuid: string, emails: string[]): Observable<Response> {
    return this.api.sendEmails(invoiceUuid, this.languageService.selectedLang, emails).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public sendLinkpayEmails(invoiceUuid: string, emails: string[]): Observable<Response> {
    return this.api.sendLinkpayEmails(invoiceUuid, this.languageService.selectedLang, emails).pipe(
      tap({ error: (e) => this.snackService.showBackendError(e) })
    );
  }

  public downloadInvoiceByUuid(invoiceUuid: string): void {
    if (invoiceUuid) {
      this.getInvoice(invoiceUuid).subscribe((invoice) => this.downloadInvoice(invoice));
    }
  }

  public downloadInvoice(invoice: InvoiceGet): void {
    if (!invoice.uuid) {
      return;
    }
    this.api.getPdf(invoice.uuid).subscribe((blob) => {
      const format = 'pdf';
      const fileName = invoice.invoiceNumber + '_' + moment(invoice.dueDate).add(-1, 'day').format('DDMMYYYY');
      const fileData = UtilService.getFileData(fileName, format);
      const file = new Blob([blob], { type: fileData.mime });
      if (this.utilService.isMobile) {
        this.utilService.mobileDownload(file, fileName);
      } else {
        this.utilService.previewOrPrintFile(file, null, null, format, fileName.replace(' ', ''));
      }
    });
  }
}
